import styled, { css } from "styled-components";
import { colors } from './../../variables';

export const ShowWrapper = styled.div`
  width: 1000px;
  background-color: transparent;
  border-radius: 0px;
  position: relative;
  margin-top: 50px;
  color: #000;
  z-index: 30;
  left: 5%;
  text-align: center;

  @media (min-width: 992px){
    .video-js .vjs-tech{
      
    }
    .myVideo-dimensions.vjs-fluid{
      padding-top: 65%;
    }
    .video-js.vjs-fluid, .video-js.vjs-16-9, .video-js.vjs-4-3{
      
    }
  }
  



  p{
    color: #fff;
  }
  button{
    justify-content: center;
    display: inline-block;
  }
  @media (max-width: 1600px){
    width: 600px;
  }
  @media (max-width: 991px){
    width: 500px;
    margin-left: -250px;
    left: inherit;
    
  }
  @media (max-width: 991px){
    position: relative;
    margin: 0 auto;
    background-color: transparent;
    margin-top: 0px;
  }
  @media (max-width: 767px){
    width: 95%;
    left: 50%;
    margin-left: -47.5%;
  }
`;

export const Sep = styled.div`
  height: 1px;
  width: 100%;
  margin: 25px 0px;
  background-color: #aaa;
  opacity: 0.3;
`;

export const ShowContent = styled.div`
  padding: 0px;
  padding-bottom: 15px;
  color: #000;
  font-weight: 300;
  text-align: center;
  background-color: #fff;
  @media (max-width: 991px){
    padding: 30px 20px;
    padding-top: 0px;
    background-color: transparent;
    padding-bottom: 0px;
    color: #000;
  }
`;

export const ShowTitle = styled.h1`
  margin-top: 20px;
  font-size: 24px;
  margin-bottom: 50px;
  text-align: 000;
  font-size: 32px;
  font-weight: 400;
  color: #000;
  font-size: 32px;
  line-height: 30px;
  span{
    font-size: 42px;
  }
  @media (max-width: 767px){
    text-align: center;
    font-size: 32px;
  }
`;

export const ShowMessage = styled.div`

  margin-top: 20px;
  padding-top: 0px;
  color: #000;
  background-color: #fff;
  text-transform: normal;
  font-size: 16px;
  p{
    color: #000;
  }
`;

export const Video = styled.div`
  background-color: #000;
  width: 100%;
  border-radius: 0px;
  overflow: hidden;
  position: relative;
  height: auto!important;
  margin: 0 auto;
  margin-top: 0px;
  border: 0px solid #aaa;
  @media (min-width: 992px){
    
  }
  @media (max-width: 767px){
    width: 100%;
    height: auto;
  }
`;

export const ShareTitle = styled.div`
  font-size: 12px;
  font-weight: 300;
  color: #fff;
  text-transform: uppercase;
`;

export const ShareList = styled.ul`
  margin: 0px;
  padding: 0px;
  margin-top: 15px;
`;

export const ShareListItem = styled.li<{color: string}>`
  list-style: none;
  display: inline-block;
  margin: 5px 5px;
  color: #fff;
  
  a{
    background-color: ${props => props.color};
    color: #fff;
    display: flex;
    font-size: 11px;
    padding: 5px 10px;
    align-items: center;
    cursor: pointer;
    border-radius: 5px;
  }
  img{
    height: 15px;
    width: auto;
    margin-right: 5px;
  }
`;